<script>
import cookieStorage from '@/plugins/cookieStorage.js'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock-upgrade'

import { COOKIE_NAMES } from '@/configs/constants'

const DELAY_BEFORE_SHOW = 3000
const DO_NOT_SHOW_WINDOW_DAYS = 31

export default {
  name: 'CookiesWindow',

  data() {
    return {
      isReady: false,
      readyTimer: null
    }
  },

  computed: {
    isShow() {
      return this.isReady && !cookieStorage.getItem(COOKIE_NAMES.noShowAppModal)
    }
  },

  mounted() {
    this.readyTimer = setTimeout(() => {
      this.isReady = true
    }, DELAY_BEFORE_SHOW)
  },

  watch: {
    isShow(value) {
      if (value) {
        this.$nextTick(() => {
          if (this.$refs.appModalRef) {
            disableBodyScroll(this.$refs.appModalRef, {
              reserveScrollBarGap: true,
            })
          }
        })
      } else {
        enableBodyScroll(this.$refs.appModalRef)
      }
    }
  },

  methods: {
    handleCloseButtonClick() {
      cookieStorage.setItem(COOKIE_NAMES.noShowAppModal, true, DO_NOT_SHOW_WINDOW_DAYS)
      this.isReady = false
    }
  }
}
</script>

<template>
  <div class="app-modal-wrapper">
    <Transition name="fade">
      <div v-if="isShow" class="overlay"></div>
    </Transition>

    <Transition name="fade">
      <div v-if="isShow" class="app-modal-container">
        <div class="app-modal" ref="appModalRef">
          <div class="info">
            <img
              src="/assets/img/logo-2.svg"
              alt="Логотип"
              loading="lazy"
              class="logo"
            />

            <div class="text">
              <!-- eslint-disable-next-line no-irregular-whitespace -->
              заказывай быстрее и удобнее в мобильном приложении
            </div>

            <div class="app-links">
              <a
                class="app-link"
                href="https://apps.apple.com/ru/app/%D0%BA%D1%80%D0%B0%D1%81%D0%BD%D0%BE%D0%B4%D0%B0%D1%80%D1%81%D0%BA%D0%B8%D0%B9-%D0%BF%D0%B0%D1%80%D0%B5%D0%BD%D1%8C/id1539906292"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/img/app_store.svg"
                  alt="Логотип App Store"
                  loading="lazy"
                  class="app-logo"
                />
              </a>

              <a
                class="app-link"
                href="https://play.google.com/store/apps/details?id=pro.arora.mobile.krasnodarskiyparen"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="/assets/img/google_play.svg"
                  alt="Логотип Google Play"
                  loading="lazy"
                  class="app-logo"
                />
              </a>
            </div>
          </div>

          <a
            href="https://krasnodar.krd-paren.ru/download"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="/assets/img/app_qr.svg"
              alt="QR код"
              class="qr"
            >
          </a>

          <svg class="close" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" @click="handleCloseButtonClick">
            <path d="M5.33594 5.33398L26.6693 26.6673M26.6693 5.33398L5.33594 26.6673" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
  .overlay {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0;
    right: 0;
    z-index: 1001;
    background: #00000080;
  }

  .app-modal-container {
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 1002;
    width: 100%;

    @media screen and (min-width: 800px) {
      bottom: initial;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 737px;
    }
  }

  .app-modal {
    border-radius: 20px 20px 0 0;
    background: #F7F0E5;
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    overflow-y: auto;
    max-height: calc(100vh - 70px);
    max-height: calc(100dvh - 70px);

    @media screen and (min-width: 800px) {
      max-height: calc(90vh);
      max-height: calc(90vh);
      border-radius: 20px;
      flex-direction: row;
      padding: 40px;
    }
  }

  .info {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    @media screen and (min-width: 800px) {
      align-items: flex-start;
    }
  }

  .logo {
    width: 77px;
    height: 80px;
  }

  .text {
    font-family: BebasNeueProExpandedExtraBoldIt;
    font-weight: 800;
    font-size: 30px;
    line-height: 112.00000000000001%;
    text-align: center;
    text-transform: uppercase;

    @media screen and (min-width: 800px) {
      text-align: left;
      font-size: 36px;
      line-height: 104%;
    }
  }

  .app-links {
    display: flex;
    justify-content: center;
    gap: 8px;
    flex-wrap: wrap;
    min-height: 40px;
  }

  .qr {
    border-radius: 16px;
    width: 90%;
    max-width: 256px;

    @media screen and (min-width: 800px) {
      max-width: initial;
      width: 280px;
      height: 280px;
    }
  }

  .close {
    position: absolute;
    top: -45px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;

    @media screen and (min-width: 800px) {
      top: 12px;
      left: initial;
      right: -60px;
    }
  }

  .fade-enter-active {
    transition: opacity 0.3s ease-out;
  }

  .fade-leave-active {
    transition: opacity 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
